import goldPatent from "../assets/patents/gold-patent.png";
import patent from "../assets/patents/patent.png";
import type { PowerupKind } from "../core/constants";

export const PATENT_IMAGE_URLS: Readonly<Record<PowerupKind, string>> = {
  "regular-patent": patent,
  "gold-patent": goldPatent,
};
